import React from 'react';
import PropTypes from "prop-types";
import {
	AjaxSpinner,
	Button,
	ColumnInformation,
	Components,
	InputInformation,
	InputList,
	MaskType,
	PopupWindow,
	SelectInput,
	Size,
	Table,
	TextInput,
	ValidationEngine,
	ValidationStyle,
	ValidationType
} from "@utahdts/dts-react-common";
import {disableScroll, dispatchUpdateData, enableScroll} from "../misc/Shared";
import clone from "clone";
import {iconExternal} from "../common/Icon";
import webservice from "../common/Webservice";
import reduxStore from "../app/ReduxStore";
import {isEmpty} from "lodash";

const propTypes = {
	statutes: PropTypes.array,
};

const defaultProps = {
	statutes: [],
};

class Statutes extends React.Component {
	constructor(props) {
		super(props);
		this.inputInformationChanged = this.inputInformationChanged.bind(this);
		this.getStatute = this.getStatute.bind(this);
		this.majorTypeChanged = this.majorTypeChanged.bind(this);
		this.minorTypeChanged = this.minorTypeChanged.bind(this);
		this.saveStatute = this.saveStatute.bind(this);
		this.checkTitle = this.checkTitle.bind(this);

		this.state = {
			currentStatute: undefined,
			currentStatuteIndex: undefined,
			editStatute: false,
			majorTypesOptions: [],
			minorTypeSelections: [],
			isSaving:false
		};

		this.columns = [
			new ColumnInformation({
				title: 'Title',
				field: 'title'
			}),
			new ColumnInformation({
				title: 'Summary',
				field: 'summary'
			})
		];

		this.inputs = [
			new InputInformation({field: 'title', label: 'Title:', type: Components.TEXT_INPUT, size: Size.FULL_WIDTH, onChange: this.inputInformationChanged, className: 'stack-form'}),
			new InputInformation({field: 'summary', label: 'Summary:', type: Components.TEXT_AREA, size: Size.FULL_WIDTH, onChange: this.inputInformationChanged, className: 'stack-form'}),
			new InputInformation({field: 'displayOrder', label: 'Display order:', type: Components.TEXT_INPUT, size: Size.XSMALL, onChange: this.inputInformationChanged, className: 'stack-form', maskType: MaskType.INTEGER_POSITIVE}),
		];

		this.validationEngine = new ValidationEngine({
			'title': [ValidationType.REQUIRED],
			'displayOrder': [ValidationType.REQUIRED],
			'majorType': [ValidationType.REQUIRED],
			'statuteNumber': [ValidationType.REQUIRED],
		});
		this.validationEngine.setValidationStyle(ValidationStyle.BLURRED);
	}

	componentDidMount() {
		webservice.admin.statutes.majorTypes().then(data => {
			data.forEach(i => {
				let type = i.type;
				let value = i.value;
				i.type = value;
				i.value = type;

			});
			this.setState({majorTypesOptions: data});
		});
	}

	inputInformationChanged(field, value) {
		this.setState({currentStatute: Object.assign(clone(this.state.currentStatute), {[field]: value})});
	}

	getStatute(statuteId) {
		let minorTypeSelections = [];
		webservice.admin.statutes.get(statuteId).then(statute => {
			let promises = [];
			let dropdowns = statute.dropdownChoices.majorTypeSelection.concat(statute.dropdownChoices.minorTypeSelection);
			dropdowns.forEach((selection, index) => {
				promises.push(webservice.admin.statutes.minorTypes(selection.value).then(data => {
					if(data.length > 0) minorTypeSelections[index] = {
						value: dropdowns[index + 1] ? dropdowns[index + 1].value : undefined,
						options: data
					};
				}));
			});
			Promise.all(promises).then(() => this.setState({
				busy: false,
				editStatute: true,
				currentStatute: statute.existingStatute,
				currentStatuteIndex: this.props.statutes.map(i => i.statuteId).indexOf(statute.existingStatute.statuteId),
				minorTypeSelections: minorTypeSelections
			}, () => disableScroll()));
		});
	}

	majorTypeChanged(value) {
		let minorTypeSelection = {value: undefined};
		let minorTypeSelections = [];
		if(value) {
			//clear then call webservice
			let uidValue = this.state.majorTypesOptions.find(type => type.value === value).type;
			this.setState({minorTypeSelections: minorTypeSelections, currentStatute: Object.assign(clone(this.state.currentStatute), {['statuteNumber']: undefined})}, () => webservice.admin.statutes.minorTypes(uidValue).then(data => {
				minorTypeSelection.options = data;
				minorTypeSelections.push(minorTypeSelection);
			}).then(() => this.setState({minorTypeSelections: minorTypeSelections}, () => this.inputInformationChanged('majorType', value))));
		}else{
			this.setState({minorTypeSelections: minorTypeSelections, currentStatute: Object.assign(clone(this.state.currentStatute), {['statuteNumber']: undefined})}, () => this.inputInformationChanged('majorType', value));
		}

	}

	minorTypeChanged(index, value) {
		let newMinorType = {value: undefined};
		let minorTypeSelections = clone(this.state.minorTypeSelections);
		let currentMinor = value ? minorTypeSelections[index].options.find(option => option.value === value) : undefined;
		let currentMinorHasChildren = currentMinor ? currentMinor.hasChildren : false;
		let statuteNumber = currentMinor ? currentMinor.statuteNumber : index > 0 ? minorTypeSelections[index - 1].options.find(option => option.value === minorTypeSelections[index - 1].value).statuteNumber : undefined;
		let minorType = currentMinor ? currentMinor.type : index > 0 ? minorTypeSelections[index - 1].options.find(option => option.value === minorTypeSelections[index - 1].value).type : undefined;

		minorTypeSelections[index].value = value;
		minorTypeSelections.splice(index + 1, minorTypeSelections.length - 1);
		this.setState({minorTypeSelections: minorTypeSelections});
		if(value && currentMinorHasChildren) {
			webservice.admin.statutes.minorTypes(value).then(data => {
				newMinorType.options = data;
				data.length > 0 && minorTypeSelections.push(newMinorType);
			}).then(() => this.setState({minorTypeSelections: minorTypeSelections, currentStatute: Object.assign(clone(this.state.currentStatute), {['statuteNumber']: statuteNumber, ['minorType']: minorType})}));
		}else{
			this.setState({minorTypeSelections: minorTypeSelections, currentStatute: Object.assign(clone(this.state.currentStatute), {['statuteNumber']: statuteNumber, ['minorType']: minorType})});
		}
	}

	checkTitle() {
		if (isEmpty(this.state.currentStatute.title) && !isEmpty(this.state.currentStatute.statuteNumber)) {
			//Change title to statute label if empty
			let minorTypeSelections = clone(this.state.minorTypeSelections);
			let currentMinorTypeSelection;
			for(let i = minorTypeSelections.length - 1; i >= 0; i--){
				if(!isEmpty(minorTypeSelections[i].value)) {
					currentMinorTypeSelection = minorTypeSelections[i];
					break;
				}
			}
			let currentMinor = currentMinorTypeSelection.options.find(option => option.value === currentMinorTypeSelection.value);
			this.setState({currentStatute: Object.assign(clone(this.state.currentStatute), {['title']: currentMinor.label})}, this.saveStatute);
		} else {
			this.saveStatute();
		}
	}

	saveStatute() {
		this.validationEngine.setValidationStyle(ValidationStyle.ALWAYS);
		let statute = clone(this.state.currentStatute);
		let store = reduxStore.getState();
		if (this.validationEngine.isValid(this.state.currentStatute)) {
			if (statute.statuteId) {
				webservice.admin.statutes.update(statute.statuteId, statute).then(() => this.closeAndUpdate());
			} else {
				statute.sessionFiscalYear = store.app.currentYear;
				statute.cobiId = store.app.currentCobiId;
				webservice.admin.statutes.add(statute).then(newStatute => {
					statute.statuteId = newStatute.statuteId;
					this.setState({currentStatute: statute}, () => this.closeAndUpdate());
				});
			}
		} else {
			this.setState({isSaving: false});
		}
	}

	closeAndUpdate() {
		this.setState({editStatute: false, minorTypeSelections: [], isSaving: false}, () => {
				dispatchUpdateData({
					path: `app.editing.background.editor.statutes`,
					field: this.state.currentStatuteIndex,
					value: this.state.currentStatute
				});
				enableScroll();
			}
		);
	}

	renderMinorTypes() {
		let minorTypeSelections = clone(this.state.minorTypeSelections);
		return minorTypeSelections.map((type, index) => (
			<SelectInput
				field={`minorType${index}`}
				key={`minorType${index}`}
				label={`Minor type ${index + 1}:`}
				value={type.value}
				className="stack-form"
				options={type.options}
				size={Size.XXLARGE}
				onChange={(field, value) => this.minorTypeChanged(index, value)}
			/>
		));
	}

	render() {
		return (
			<div className="clearfix collapsible-section mt-spacing-large">
				{this.state.busy && <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/>}
				<div className="clearfix collapsible-section__title">
					<h3 className="mt-spacing-large table-title">Statutes</h3>
				</div>
				<div>
					<Table
						columns={this.columns}
						list={this.props.statutes}
						onRowClick={statute => this.setState({busy: true}, () =>this.getStatute(statute.statuteId))}
						className="statutes issues issues-other clickable"
					/>
					<Button label="Add statute"
							onClick={() => this.setState({
								editStatute: true,
								currentStatute: {
									summary: '',
									isActive: true,
									displayOrder: this.props.statutes.length + 1
								},
								currentStatuteIndex: this.props.statutes.length
							}, () => disableScroll())}
							className="primary float-right mtb-spacing"/>
				</div>

				{this.state.editStatute && <PopupWindow
					footerChildren={<React.Fragment>
						<Button label="Cancel"
								onClick={() => this.setState({editStatute: false, minorTypeSelections: []}, () => enableScroll())}
								className="grey"
								disabled={this.state.isSaving}/>
						<Button label="Save statute"
								className="blue"
								onClick={() => this.setState({isSaving: true}, () => this.checkTitle())}
								busy={this.state.isSaving}/>
					</React.Fragment>}
					className="popup-window--xlarge">
					<h3>Editing statute</h3>
					<InputList inputs={this.inputs} data={this.state.currentStatute} validationEngine={this.validationEngine}/>
					<div className="mt-spacing-small mb-spacing flex align-center">
						<label htmlFor="isActive">Active</label>
						<label className="switch ml-spacing-small">
							<input
								type="checkbox"
								name="isActive"
								checked={this.state.currentStatute.isActive}
								onChange={e => this.inputInformationChanged("isActive", e.target.checked)}
							/>
							<span className="slider round"/>
						</label>
					</div>
					<SelectInput
						field="majorType"
						label="Major type:"
						value={this.state.currentStatute.majorType}
						className="stack-form"
						options={this.state.majorTypesOptions}
						onChange={(field, value) => this.majorTypeChanged(value)}
						validationEngine={this.validationEngine}
					/>
					{this.state.currentStatute.majorType && this.state.minorTypeSelections.length > 0 && this.renderMinorTypes()}
					<TextInput
						field="statuteNumber"
						label="Statute number:"
						value={this.state.currentStatute.statuteNumber}
						className="stack-form"
						disabled={true}
						size={Size.XLARGE}
						onChange={(field, value) => this.inputInformationChanged('statuteNumber', value)}
						validationEngine={this.validationEngine}
					/>
					<div className="input-container">
						<a href={`https://le.utah.gov/UtahCode/LibLookup.jsp?maj=${this.state.currentStatute.majorType}&min=${this.state.currentStatute.minorType}&num=${this.state.currentStatute.statuteNumber}`} target="_blank" className="flex-inline flex align-center button-alike">
							{iconExternal("mr-spacing-small")}
							<span className="button-label">Preview statute link</span>
						</a>
					</div>
				</PopupWindow>}
			</div>
		);
	}
}

Statutes.propTypes = propTypes;
Statutes.defaultProps = defaultProps;

export default Statutes;
